module.exports = __webpack_public_path__ + "static/ic_win@2x.cdfd96b3.png";